export const createRoot = (theme) => {
  return {
    '& .MuiInputBase-input.MuiInput-input, & .datePicker .MuiInputBase-root, & .ships .MuiInputBase-root ':
      {
        background: theme.palette.white,
        border: `solid 1px ${theme.palette.grey7}`,
        borderRadius: 3,
        height: 50,
        boxSizing: 'content-box',
        lineHeight: theme.typography.pxToRem(20),
      },
    '& .MuiInputBase-input.MuiInput-input': {
      boxSizing: 'border-box',
      padding: '0 20px',

      [theme.breakpoints.down('lg')]: {
        padding: '0 10px',
      },
    },
    '& .MuiFormHelperText-root': {
      marginTop: '10px',
    },
    '& .MuiInputBase-input.MuiInput-input:-webkit-autofill, & .MuiInputBase-input.MuiInput-input:-webkit-autofill:hover, & .MuiInputBase-input.MuiInput-input:-webkit-autofill:focus':
      {
        backgroundColor: 'white',
      },
    '& .Mui-error .MuiInputBase-input': {
      border: `1px solid ${theme.palette.critical}`,
    },
    '& .datePicker': {
      '& .MuiInputAdornment-root': {
        background: 'transparent',
        marginLeft: '20px',
        marginRight: '-13px',
        width: '24px',

        [theme.breakpoints.down('lg')]: {
          marginLeft: '10px',
          marginRight: '0px',
        },
      },
      '& .Mui-error': {
        '&.MuiInputBase-root': {
          border: `solid 1px ${theme.palette.critical}`,
          fontSize: theme.typography.pxToRem(12),
          lineHeight: theme.typography.pxToRem(18),
        },
      },
      '& .MuiInputBase-input': {
        border: `none`,
      },
      '& .MuiInputBase-input::placeholder': {
        color: theme.palette.grey8,
        opacity: 1,
      },
    },
    '& .ships': {
      '& .MuiInputBase-input': {
        border: `none`,
        display: 'flex',
        alignItems: 'center',
      },
    },
    '& .MuiGrid-root.MuiGrid-item': {
      padding: '16px 0px 20px',
      [theme.breakpoints.down('sm')]: {
        paddingBottom: 23,
      },
    },
    '& .MuiGrid-root.MuiGrid-item:nth-child(odd)': {
      paddingRight: 10,
      [theme.breakpoints.only('xs')]: {
        paddingRight: 0,
      },
    },
    '& .MuiGrid-root.MuiGrid-item:nth-child(even)': {
      paddingLeft: 10,
      [theme.breakpoints.only('xs')]: {
        paddingLeft: 0,
      },
    },
    '& .MuiGrid-root.MuiGrid-item:last-child': {
      paddingRight: 0,
    },
    '& .MuiButtonBase-root.MuiButton-containedPrimary': {
      ...{
        background: theme.palette.grey2,
        borderRadius: 3,
        boxShadow: 'none',
        height: 50,
        color: 'white',
        float: 'right',
        margin: '0',
        maxWidth: '246px',
        [theme.breakpoints.down('xs')]: {
          margin: '16px 0 0',
          maxWidth: '100%',
        },
        padding: '12px',
        width: '100%',
      },
      fontSize: theme.typography.pxToRem(18),
      lineHeight: theme.typography.pxToRem(22),
      fontFamily: theme.typography.proxima.semiBold,
      textTransform: 'none',

      [theme.breakpoints.between('md', 'lg')]: {
        fontSize: theme.typography.pxToRem(15),
        lineHeight: theme.typography.pxToRem(18),
      },
    },

    '& .MuiButton-containedPrimary:not(.Mui-disabled)': {
      background: theme.palette.blue2,
      color: theme.palette.white,
    },
    '& .MuiButtonBase-root.MuiButton-outlinedPrimary': {
      ...{
        background: 'white',
        border: `1px solid ${theme.palette.blue2}`,
        borderRadius: '3px',
        boxShadow: 'none',
        color: theme.palette.blue2,
        height: '50px',
        minWidth: '125px',
        padding: '12px 30px',
        width: 'auto',
        [theme.breakpoints.down('xs')]: {
          width: '100%',
        },
      },
      ...theme.rccl.labelSmallBold,
    },
    '& .MuiGrid-item.actions': {
      padding: '10px 0',
    },
  };
};

export const createFormLayout = (theme) => {
  return {
    maxWidth: 1080,
    marginTop: 0,
    marginBottom: theme.spacing(8),
    padding: 20,

    [theme.breakpoints.up('sm')]: {
      padding: '0 50px',
      paddingTop: 24,
    },
    [theme.breakpoints.up('lg')]: {
      padding: '0 35px',
      paddingTop: 24,
    },

    '&.FormFutureCruiseCredit': {
      marginTop: 0,
    },
    '&.hideSubmitButton': {
      marginBottom: theme.spacing(1),
    },
    '& .form__title': {
      color: theme.palette.blue1,
      fontSize: theme.typography.pxToRem(36),
      letterSpacing: '0',
      marginBottom: '10px',
      lineHeight: '150%',
      fontFamily: theme.typography.proxima.semiBold,

      [theme.breakpoints.down('lg')]: {
        fontSize: theme.typography.pxToRem(30),
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(24),
      },
    },
    '& .form__subTitle': {
      display: 'inline-block',
      color: theme.palette.grey1,
      letterSpacing: '0',
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(27),
      marginBottom: theme.typography.pxToRem(24),
      '& strong': {
        fontWeight: 400,
        fontFamily: theme.typography.proxima.semiBold,
      },
      '& .spacer': {
        marginBottom: '10px !important',
        display: 'flex',
      },
      [theme.breakpoints.up('md')]: {
        '& .emptyBookingStrong': {
          fontSize: theme.typography.pxToRem(20),
        },
      },
      [theme.breakpoints.up('lg')]: {
        '& emptyBookingRegular': {
          fontSize: theme.typography.pxToRem(20),
        },
      },
      [theme.breakpoints.up('xl')]: {
        '& .emptyBookingStrong': {
          fontSize: theme.typography.pxToRem(24),
        },
        '& .emptyBookingRegular': {
          fontSize: theme.typography.pxToRem(18),
        },
      },
      [theme.breakpoints.up('lg')]: {
        '& .withoutGAP': {
          fontSize: theme.typography.pxToRem(18),
          lineHeight: '150%',
        },
      },
    },
    '& .form__subTitle.MuiTypography-root': {
      [theme.breakpoints.down('sm')]: {
        lineHeight: theme.typography.pxToRem(24),
      },
    },
    '& form label': {
      width: '133%',
      marginTop: '-7px',
    },
  };
};
